module.exports = __webpack_public_path__ + "img/img3.ddc1d849.png";